import TreatmentFullLayout from "../../components/TreatmentLayout";
import Service3 from "../../assets/images/service/03.jpg";

import ImgDialysis from "../../assets/images/service_detail/hemodialysis/01.jpg";
import ImgFistula from "../../assets/images/service_detail/hemodialysis/02.jpg";
import ImgFistula2 from "../../assets/images/service_detail/hemodialysis/03.jpg";
import ImgCare from "../../assets/images/service_detail/hemodialysis/04.jpg";

const Hemodialysis = () => {

const data = {
title:"Hemodialysis & AV Fistula Creation",
subtitle:"Advanced dialysis access & kidney care at BBMH Hospital",

heading:"Best Hemodialysis & AV Fistula Specialist in Bhilwara",
description:"Hemodialysis is a life-saving treatment for patients with kidney failure. At BBMH (Brijesh Banger Memorial Hospital), advanced dialysis support and AV fistula creation procedures are performed by Dr. Sachitanand Chaurasia to ensure safe and effective long-term kidney care.",

image:Service3,

sections:[

{
title:"What is Hemodialysis?",
content:"Hemodialysis is a medical procedure that removes waste, toxins and excess fluids from the blood when kidneys stop functioning properly. It is required for patients suffering from chronic kidney disease (CKD) or kidney failure. Hemodialysis helps maintain electrolyte balance, control blood pressure and improve overall health when kidneys cannot perform their normal function.",
image: ImgDialysis
},

{
title:"What is AV Fistula Creation?",
content:"AV (Arteriovenous) fistula creation is a minor surgical procedure performed to create a permanent access for hemodialysis. In this procedure, an artery and vein are connected to allow easy and long-term dialysis access. AV fistula is considered the best and safest dialysis access because it provides better blood flow, lasts longer and has fewer complications compared to other dialysis methods.",
image: ImgFistula
},

{
title:"Who Needs Hemodialysis?",
content:"Hemodialysis is required when kidneys are unable to filter waste, toxins and excess fluids from the blood properly. It helps maintain normal body balance and supports life in patients with severe kidney problems.",
list:[
"Chronic Kidney Disease (CKD) – Long-term kidney damage leading to reduced kidney function.",
"Kidney Failure – When kidneys stop working and cannot remove toxins naturally.",
"High Creatinine Levels – Increased waste products in blood due to poor kidney function.",
"Fluid Overload – Excess fluid accumulation causing swelling and breathing difficulty.",
"Severe Electrolyte Imbalance – Dangerous changes in potassium, sodium or other minerals.",
"Patients Awaiting Kidney Transplant – Dialysis supports body function until transplant."
]
},

{
title:"Benefits of AV Fistula for Dialysis",
content:"AV fistula is the safest and most reliable long-term access for hemodialysis. It is created by connecting an artery and vein to allow smooth blood flow during dialysis sessions.",
list:[
"Provides permanent and long-term dialysis access",
"Ensures better blood flow for effective dialysis",
"Lower risk of infection compared to catheter",
"Less chances of blockage or complications",
"Durable and long-lasting access",
"Improves overall dialysis efficiency and patient comfort"
]
},

{
title:"Procedure of AV Fistula Creation",
content:"AV fistula creation is a minor and safe surgical procedure performed under local or regional anesthesia. The surgeon connects a vein and artery in the arm to create a strong blood vessel for dialysis access. This connection improves blood flow and allows repeated dialysis safely. The fistula usually takes a few weeks to mature before it is ready for regular dialysis use. The procedure is completed within 1–2 hours with minimal discomfort and quick recovery.",
image: ImgFistula2
},

{
title:"Dialysis Care & Monitoring",
content:"Proper care and regular monitoring are essential for patients undergoing dialysis to maintain health and prevent complications. Following medical advice and maintaining hygiene ensures effective dialysis and long-term kidney care.",
list:[
"Regular dialysis sessions as advised by doctor",
"Monitoring blood pressure and body weight",
"Controlled diet and fluid intake",
"Routine blood tests and kidney function monitoring",
"Proper AV fistula care and hygiene",
"Regular follow-up with doctor for overall health"
],
image: ImgCare
},

{
title:"Why Choose Dr. Sachitanand Chaurasia for Dialysis & AV Fistula?",
content:"Dr. Sachitanand Chaurasia is an experienced urologist and kidney specialist providing advanced dialysis support and AV fistula creation at BBMH (Brijesh Banger Memorial Hospital), Bhilwara. The hospital offers modern dialysis facilities, safe surgical procedures and complete kidney care under expert supervision ensuring best outcomes for patients."
}

],

faq:[
{
q:"Is AV fistula surgery painful?",
a:"No, it is a minor procedure performed under anesthesia and mostly painless."
},
{
q:"How long does AV fistula last?",
a:"AV fistula can last for many years with proper care and regular monitoring."
},
{
q:"Is dialysis permanent?",
a:"Dialysis is required for kidney failure patients until kidney function improves or transplant is done."
}
]
};

return <TreatmentFullLayout data={data}/>
};

export default Hemodialysis;